import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import I_CHARGES from '../interfaces/I_CHARGES';
import {
  getChargesWithoutPaginationResponse,
  postChargesReportResponse,
  getChargesReportResponse,
  cancelChargesReportResponse,
  validateChargesReportResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- CHARGES REPORT
// ---------------------------------

const logger = LoggerService.getInstance();



interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  from_date: string;
  from_date_end: string;
  to_date: string;
  to_date_end: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  collaborators: string;
  // referential_customers: string;
  audited_customers: string;
  referentials: string;
}
/**
 * Récupère la liste des charges sans pagination
 * @param obj
 * @returns
 */
const getChargesList = async ({
  accessToken,refreshToken,dispatch,state,
  from_date,from_date_end,
  to_date,to_date_end,
  activity_types,
  directions_ops,hubs_ops,
  collaborators,
  // referential_customers,
  audited_customers,
  referentials,
}:I_GET_PARAMS):Promise<I_CHARGES> => {
  logger.debug('ApiServices - getChargesWithoutPagination');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargesWithoutPaginationResponse({
        accessToken:usedAccessToken,
        from_date,from_date_end,
        to_date,to_date_end,
        activity_types,
        directions_ops,hubs_ops,
        collaborators,
        audited_customers,
        referentials,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getChargesWithoutPagination - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGES = await response.json();
  logger.debug('ApiServices - getChargesWithoutPagination - ok, returned body',body);
  return body;
};


interface I_CREATE_CHARGES_REPORT_PARAMS {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401

  chargesIdSelected: number[];
  postpone_date: string;
  status_hourly_volume: 'INCREASE' | 'DECREASE' | 'KEEP';
  hourly_volume: number;
  keep_activities: boolean;
  keep_collaborators: boolean;
}
/**
 * Crée un report de charges
 * @param param0
 * @returns
 */
const create = async ({
  accessToken,refreshToken,
  dispatch,state,
  chargesIdSelected,
  postpone_date,
  status_hourly_volume,
  hourly_volume,
  keep_activities,
  keep_collaborators,
}:I_CREATE_CHARGES_REPORT_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createChargesReport - ...');
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    chargesIdSelected === undefined || chargesIdSelected === null || chargesIdSelected.length === 0 ||
    !postpone_date || postpone_date === null || postpone_date.trim() === '' ||
    !status_hourly_volume || status_hourly_volume === null || status_hourly_volume.trim() === '' ||
    hourly_volume === undefined || hourly_volume === null
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post charges report',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postChargesReportResponse({
        accessToken:usedAccessToken,
        chargesIdSelected,
        postpone_date,
        status_hourly_volume,
        hourly_volume,
        keep_activities,
        keep_collaborators,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createChargesReport - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createChargesReport - ok, returned body',body);
  logger.info(...formatInfo('Charges report created!'));
  return body;
};

interface I_GET_PROPS extends I_COMMON_GET_ALL_PARAMS {
  id_postpone: number;
}
/**
 * Récupère la liste des charges
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,dispatch,state,
  id_postpone,
}:I_GET_PROPS):Promise<I_CHARGES> => {
  logger.debug('ApiServices - charges-report - getList...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargesReportResponse({
        accessToken:usedAccessToken,
        id_postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - charges-report - getList - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGES = await response.json();
  logger.debug('ApiServices - charges-report - getList - ok, returned body',body);
  return body;
};

interface I_CANCEL {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
  id_postpone: number;
}
/**
 * Crée un report de charges
 * @param param0
 * @returns
 */
const cancel = async ({
  accessToken,refreshToken,
  dispatch,state,
  id_postpone,
}:I_CANCEL):Promise<string> => {
  logger.debug('ApiServices - cancelChargesReport - ...');
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id_postpone === undefined || id_postpone === null
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to cancel charges report',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return cancelChargesReportResponse({
        accessToken:usedAccessToken,
        id_postpone,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - cancelChargesReport - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - cancelChargesReport - ok, returned body',body);
  logger.info(...formatInfo('Charges report canceled!'));
  return body;
};


interface I_CANCEL {
  accessToken: string,
  refreshToken: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
  id_postpone: number;
}
/**
 * Crée un report de charges
 * @param param0
 * @returns
 */
const validate = async ({
  accessToken,refreshToken,
  dispatch,state,
  id_postpone,
}:I_CANCEL):Promise<string> => {
  logger.debug('ApiServices - validateChargesReport - ...');
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id_postpone === undefined || id_postpone === null
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to validate charges report',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return validateChargesReportResponse({
        accessToken:usedAccessToken,
        id_postpone,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - validateChargesReport - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - validateChargesReport - ok, returned body',body);
  logger.info(...formatInfo('Charges report validated!'));
  return body;
};

const chargesReportServices = {
  getChargesList,
  create,
  getList,
  cancel,
  validate,
};

export default chargesReportServices;
